import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    setSelectedRisk
} from '../../../actions';
import ReactTooltip from 'react-tooltip';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faClock, faInfo, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './EsgRiskRatingRow.css';
//import EsgOverallMetric from './EsgOverallMetric';
import i18n from '../../../i18n';
import EsgRiskContributorRows from './EsgRiskContributorRows';

library.add(faClock, faAngleDown, faAngleUp, faQuestionCircle, faInfo);

class EsgRiskRatingRow extends Component {

    state = { showing: false };


    setSelectedRisk(char) {
        this.props.setSelectedRisk(char);
    }
    // formatPercent(number) {
    //     return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-';
    //   }

    formatValue(type, val) {
        if (typeof (val) === 'number' && type === '.') {

            return (val !== null ? `${parseFloat(val * 100).toFixed(2)}` : val);
        } else if (typeof (val) === 'number') {
            return (val !== null ? `${parseFloat(val).toFixed(2)}` : val);
        } else {
            return (val);
        }
    }

    getContributorDetails(type, data, rank, tipType) {
        const values = [];
        for (let i = 0; i < data.length; i++) {
            const fund = data[i];
            if (fund.esgOverallContributions) {
                const involvements = fund.esgOverallContributions[fund.esgOverallContributions.length - 1]
                let value = '-';
                //get Contribtors vs detractors 
                const prods = involvements.keys.filter((x) => x.includes(type + '|'));
                if (prods !== -1) {
                    value = prods[rank - 1];
                    let parts = value.split('|')  // 2-id , 3-ticker, 4-holding name , 5-weight 
                    parts[4].replace(/&amp;/g, '&')
                    value = (tipType === 'tooltip') ? parts[4] : parts[3] + '--' + parts[5]
                    values.push(value);
                } else {
                    values.push('-');
                }
            } else {
                values.push('-');
            }
        }
        return values;
    }

    renderRiskContributors() {
        const { data } = this.props;
        const metrics = [
            {
                bold: 'max', subGroup: 'M',
                displayName: 'Highest Risk Contributor',
                description: ' % of Fund',
                hideline: false,
                name: 'Highest',
                type: '.',
                append: '',
                tooltips: this.getContributorDetails('C', data, 1, 'tooltip'),
                values: this.getContributorDetails('C', data, 1, 'ticker-wgt')
            },
            {
                bold: 'max',
                displayName: 'Second Highest Risk Contributor',
                description: ' % of Fund',
                hideline: false,
                name: 'Second',
                type: '.',
                append: '',
                tooltips: this.getContributorDetails('C', data, 2, 'tooltip'),
                values: this.getContributorDetails('C', data, 2, 'ticker-wgt')
            },
            {
                bold: 'max', subGroup: 'M',
                displayName: 'Third Highest Risk Contributor',
                description: ' % of Fund',
                hideline: false,
                name: 'Third',
                type: '.',
                append: '',
                tooltips: this.getContributorDetails('C', data, 3, 'tooltip'),
                values: this.getContributorDetails('C', data, 3, 'ticker-wgt')
            },
        ];
        return metrics.map(metric => {
            return (
                <EsgRiskContributorRows
                    key={metric.displayName}
                    displayName={metric.displayName}
                    description={metric.description}
                    values={metric.values}
                    append={metric.append}
                    bold={metric.bold}
                    hideLine={metric.hideLine}
                    tooltips={metric.tooltips}
                    type={metric.type}
                    name={metric.name}
                />
            );
        });
    }
    render() {
        const {
            displayName,
            charName,
            description,
            values,
            tooltips,
            bold,
            hideLine,
            type,
            name,
        } = this.props;

        const { showing } = this.state;

        let parsedValues =
            values.map((val) => {

                let x = val + "";
                let str = x.split("--");
                if (str.length <= 1) {
                    return (str[0]);
                }
                if ((str.length > 1) && (str[2] === 'peer')) {
                    return (str[0]);
                } else {
                    const lastItem = str[1][str[1].length - 1];
                    if (lastItem === '%') {
                        return (
                            Number(str[1].substring(0, str[1].length - 1)));
                    }
                    return (str[1])
                }
            })

        let match = Math.max(...parsedValues.filter((val) => { return val !== null && val !== '-'; }));
        if (bold === 'min') {
            match = Math.min(...parsedValues.filter((val) => { return val !== null; }));
        }

        const columns = values.map((value, colIdx) => {

            if (!value) {
                return (<td key={colIdx} className='textCenter'>-</td>);
            } else {
                let valueClass = 'textCenter';
                if (Number(value) === match) {
                    valueClass = 'textCenterBold';
                }
                value = this.formatValue(type, value)
                const parts = value.split('--')
                const ticker = parts[1];
                const weight = parts[0];

                if (Number(weight) === match) {
                    valueClass = 'textCenterBold';
                }
                return (
                    <td key={`${name}-${colIdx}`} className={valueClass}>
                        {weight}
                        <div className={valueClass} >
                            {ticker}
                            {tooltips && weight !== '-' &&
                                <Fragment >
                                    <FontAwesomeIcon style={{ marginLeft: '4px', cursor: 'pointer', color: 'white', background: 'grey', borderRadius: '50%', border: '1px solid grey', fontSize: '12px', width: '.9em' }} data-tip data-for={`contrib' ${name}-${colIdx}`} icon="info" size="lg" />
                                    <ReactTooltip id={`contrib' ${name}-${colIdx}`} type='light' className="esg" effect="float">
                                        <div dangerouslySetInnerHTML={{ __html: tooltips[colIdx] }} />
                                    </ReactTooltip>
                                </Fragment>
                            }
                        </div>
                    </td>
                );
            }
        });

        return (
            <tbody className={hideLine ? 'noLine' : ''} style={{ 'borderTop': '4px' }}>
                <tr >
                    <td className='textLeft'>
                        <div onClick={() => this.setState({ showing: !showing })} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                            {showing && charName === 'overallRisk' &&
                                <FontAwesomeIcon style={{ color: '#050139' }} icon='angle-down' />
                            }
                            {!showing && charName === 'overallRisk' &&
                                <FontAwesomeIcon style={{ color: '#050139' }} icon='angle-up' />
                            }
                            &nbsp;&nbsp; {i18n.t(displayName)} <br />
                            <span style={{ fontStyle: 'italic', color: '#8c959b' }}>  &nbsp;&nbsp; &nbsp;&nbsp;{description}</span>
                        </div>
                    </td>
                    <td className='textLeft'>
                        <div></div>
                    </td>
                    {columns}
                </tr>

                {showing && charName === 'overallRisk' &&
                    <Fragment> {this.renderRiskContributors()}</Fragment>
                }

            </tbody>
        );
    }
}

function mapStateToProps(state) {
    return {
        data: state.fundData.data,
        selectedRisk: state.params.selectedRisk
    };
}

export default connect(mapStateToProps, {
    setSelectedRisk,
})(EsgRiskRatingRow);
